// extracted by mini-css-extract-plugin
module.exports = {"heroLogo":"product_category-module--heroLogo--1ODft","heroSubtitle":"product_category-module--heroSubtitle--y0dYU"};